import l10n from "./v3.0.0/lib/l10n";

export const CROPPER_META_KEY = '_wppr_cropper';

export const URL_PARAM_PRESET_LEGACY = 'cp';
export const URL_PARAM_PRESET = 'wppr_cropper';
export const URL_PARAM_INIT = 'wppr_cropper_init';

export const ACTION_ORDER = Symbol("ACTION_ORDER");
export const ACTION_QUOTE = Symbol("ACTION_QUOTE");
export const ACTION_BUY_NOW = Symbol("ACTION_BUY_NOW");
export const ACTION_UPDATE_CART = Symbol("ACTION_UPDATE_CART");
export const ACTION_DEBUG = Symbol("ACTION_DEBUG");
export const ACTION_ADD_CART = Symbol("ACTION_ADD_CART");
export const ACTION_ADD_TO_CART = Symbol("ACTION_ADD_TO_CART");
export const ACTION_EMAIL_PREVIEW = Symbol("ACTION_EMAIL_PREVIEW");

export const STATUS_SUCCESS = Symbol("STATUS_SUCCESS");
export const STATUS_ERROR = Symbol("STATUS_ERROR");
export const STATUS_QUEUED = Symbol("STATUS_QUEUED");
export const STATUS_INTERRUPT = Symbol("STATUS_INTERRUPT");

export const wp_ajax_hook = {
  [ACTION_BUY_NOW]: 'woocommerce_add_to_cart',
  [ACTION_ADD_CART]: 'woocommerce_add_to_cart',
  [ACTION_ADD_TO_CART]: 'woocommerce_add_to_cart',
  [ACTION_ORDER]: 'wppr_process_order',
  [ACTION_QUOTE]: 'wppr_process_quote',
  [ACTION_DEBUG]: 'wppr_ajax_order_debug',
  // [ACTION_EMAIL_PREVIEW]: 'wppr_email_preview'
  [ACTION_EMAIL_PREVIEW]: 'wppr_email_customprint_link'
};

export const wp_nonce = {
  [ACTION_BUY_NOW]: 'wc_nonce',
  [ACTION_ADD_CART]: 'wc_nonce',
  [ACTION_ADD_TO_CART]: 'wc_nonce',
  [ACTION_ORDER]: 'wc_checkout_nonce',
  [ACTION_QUOTE]: 'wc_checkout_nonce',
  [ACTION_DEBUG]: 'wc_nonce',
  [ACTION_EMAIL_PREVIEW]: 'wc_nonce',
};

export const required_ajax_data = [
  'billing_first_name',
  'billing_last_name',
  'billing_country',
  'billing_address_1',
  'billing_postcode',
  'billing_city',
  'billing_state',
  'billing_phone',
  'billing_email',
]

export const additional_ajax_data = {
  [ACTION_BUY_NOW]: {},
  [ACTION_ADD_CART]: {},
  [ACTION_ADD_TO_CART]: {},
  [ACTION_ORDER]: {
    // wc checkout required fields
    'billing_first_name': l10n?.u_billing_first_name,
    'billing_last_name': l10n?.u_billing_last_name,
    'billing_country': l10n?.u_billing_country,
    'billing_address_1': l10n?.u_billing_address_1,
    'billing_postcode': l10n?.u_billing_postcode,
    'billing_city': l10n?.u_billing_city,
    'billing_state': l10n?.u_billing_state,
    'billing_phone': l10n?.u_billing_phone,
    'billing_email': l10n?.u_billing_email,
    'payment_method': 'cod',
    // others
    'order_comments': '',
    'terms': false,
    'createaccount': false,
    'wppr_order_factory': 'wallpaper',
  }
};